import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { BmsjHipsterSharedModule } from '../../shared';
import { SampleComponent, SampleManagerComponent, SampleResolvePagingParams, SAMPLE_ROOT_ROUTES, SampleService } from './';
import { TreeTableComponent } from './tree-table/tree-table.component';
import { SampleTreeService } from './tree-table/sample-tree.service';

import { SampleSearchListComponent } from './sample-search-list.component';
import { SampleListService } from './sample-list.service';
import { SampleGenotypeService } from './genotype/sample-genotype.service';
import { FileDownloadHelper } from './file-download.helper';
import { SampleImportPlateComponent } from './sample-import-plate.component';
import { ExcelService } from './excel.service';
import { SampleImportPlateMappingComponent } from './sample-import-plate-mapping.component';
import { SampleContext } from './sample.context';
import { SampleGenotypeImportModalComponent } from './genotype/sample-genotype-import-modal.component';
import { SampleGenotypeImportFileComponent } from './genotype/sample-genotype-import-file.component';
import { TruncateSpanComponent } from '../../shared/util/span-truncate/truncate-span.component';
import { HelpLinkComponent } from '../../shared/help-link/help-link.component';

@NgModule({
    imports: [
        BmsjHipsterSharedModule,
        RouterModule.forChild([...SAMPLE_ROOT_ROUTES]),
        TruncateSpanComponent,
        HelpLinkComponent
    ],
    declarations: [
        SampleComponent,
        SampleManagerComponent,
        TreeTableComponent,
        SampleSearchListComponent,
        SampleImportPlateComponent,
        SampleImportPlateMappingComponent,
        SampleGenotypeImportModalComponent,
        SampleGenotypeImportFileComponent
    ],
    providers: [
        SampleService,
        SampleListService,
        SampleResolvePagingParams,
        SampleTreeService,
        FileDownloadHelper,
        ExcelService,
        SampleContext,
        SampleGenotypeService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BmsjHipsterSampleModule {}
